const API_URL = process.env.REACT_APP_API_URL || 'https://alonewithgod.ru';

export default API_URL;
